import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { clarityItems } from '../data/content';
export function VisionSection() {
  return <section className="bg-ink px-4 py-16 sm:py-24" data-id="element-356" data-mp="1pq0q7xnh270p">
      <div className="mx-auto max-w-3xl" data-id="element-357" data-mp="1unalhtxjlcwg">
        <SectionHeading dark eyebrow="Here’s what I want you to be able to do" title={<>See your <em className="text-gold-light" data-id="element-359" data-mp="2ie6euvhncg5t">entire process</em> in front of you.</>} data-id="element-358" data-mp="1uo2kleqclsrh" />
        <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-relaxed text-white/75" data-id="element-360" data-mp="2nchksv4tm6ir">
          Imagine sitting down with your workflow and finally being able to see the entire process. You know:
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-361" data-mp="2dl3pz0ntduvy">
          {clarityItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-coal px-4 py-4 ring-1 ring-white/10" data-id="element-362" data-mp="31b7jgf7age98">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-363" data-mp="3640nf0uxnik9">
                <CheckIcon className="h-5 w-5 text-ink" strokeWidth={3} aria-hidden="true" data-id="element-364" data-mp="3plva0d9p5kt5" />
              </span>
              <span className="text-[17px] font-semibold text-white" data-id="element-365" data-mp="3kkpfqb0e1phi">{item}</span>
            </li>)}
        </ul>

        <p className="mt-10 text-center text-lg text-white/70" data-id="element-366" data-mp="3tngt4gctqvbs">And most importantly…</p>
        <p className="mx-auto mt-3 max-w-2xl text-center font-serif text-3xl sm:text-4xl font-black leading-tight text-gold-light" data-id="element-367" data-mp="c6qk5ahbw64j">
          You no longer have to keep your entire workflow inside your head.
        </p>

        <SectionCta dark label="Get my workflow out of my head" data-id="element-368" data-mp="l7x4xvr0g33l" />
      </div>
    </section>;
}